import { apiRequest, apiRequestAll } from './http'

export interface StockDto {
  id: number | string
  storeId: number | string
  productId: number | string
  quantity: number | string
  safetyStock: number | string
  version: number | string
  status: string
}

export interface DocumentDto {
  id: number | string
  type: string
  documentNo: string
  businessDate: string
  storeId: number | string
  toStoreId?: number | string
  reasonText?: string
  reasonCode?: string
  status: string
  voidReason?: string
  createdByName?: string
  createdAt?: string
  items?: Array<{ productId: number | string; quantity: number | string; remark?: string }>
}

export interface LedgerDto {
  id: number | string
  time: string
  storeId: number | string
  productId: number | string
  type: string
  delta: number | string
  before: number | string
  after: number | string
  operator: string
  remark: string
  source: string
}

export const inventoryApi = {
  stocks: () => apiRequestAll<StockDto>('/inventory/stocks'),
  documents: () => apiRequestAll<DocumentDto>('/inventory/documents'),
  ledger: async () => (await apiRequest<{ items: LedgerDto[] }>('/inventory/ledger', {
    query: { page: 1, pageSize: 100 }
  })).data.items,
  saveSafety: (items: unknown[]) => apiRequest('/inventory/safety-stocks', {
    method: 'PUT', body: { items }
  }),
  createDocument: (body: Record<string, unknown>) => {
    if (body.type === 'transfer') {
      return apiRequest('/owner/transfers', {
        method: 'POST',
        idempotent: true,
        body: {
          fromStoreId: body.storeId,
          toStoreId: body.toStoreId,
          businessDate: body.businessDate,
          remark: body.reasonText,
          items: body.items
        }
      })
    }
    return apiRequest('/inventory/documents', { method: 'POST', body, idempotent: true })
  },
  voidDocument: (id: number, reason: string) => apiRequest(`/inventory/documents/${id}/void`, {
    method: 'POST', body: { reason }
  })
}
